import markItemsAsReadBasedOnItemIds from '../helpers/markItemsAsReadBasedOnItemIds';
import * as suppressedItemIdsMapOperations from '../helpers/suppressedItemIdsMapOperations';
import { getViewFilterForTable } from 'owa-mail-list-store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Try perform auto mark as read on item
 * @param itemId the item id to be auto marked as read
 * @param tableView the table view
 */
export default action('autoMarkItemAsRead')(function autoMarkItemAsRead(itemId, tableView) {
    if (getViewFilterForTable(tableView) == 'Unread') {
        // Auto mark as read is not supported in Unread view filter
        return;
    }
    // Do not perform auto mark as read if item is in suppressed map
    if (suppressedItemIdsMapOperations.contains([itemId])) {
        return;
    }
    markItemsAsReadBasedOnItemIds(tableView, [itemId], true /* isReadValueToSet */, false /* isExplicit */, 'NonUserAction' /* actionSource */, [] /* instrumentationContexts */);
    // Clear the suppressed itemIds map
    suppressedItemIdsMapOperations.clear();
});
//# sourceMappingURL=autoMarkItemAsRead.js.map